module.exports = __webpack_public_path__ + "static/media/whatsapp.a59e768e.png";